import React from 'react';
import type { PropertyLoan, PropertyRecord } from 'bundles/connect/types';
import PropertyRecords from './property_records';
import PropertyLoans from './property_loans';

type Props = {
  loans: PropertyLoan[];
  records: PropertyRecord[];
}

export default function RecordsSection({ loans, records }: Props) {
  return (
    <div className="d-flex flex-column gap-6">
      <PropertyLoans loans={loans} />
      <PropertyRecords records={records} />
    </div>
  );
}
